import axios from 'axios';
import qs from 'qs';

const API_Url = 'http://w-s/';

export default {
	actions: {
		AllMethodsAct({commit}) {
			axios.get(API_Url + 'docs/method.get')
			.then((response) => {
				const MethodRes = response.data.response;
				commit('AllMethodsMut', MethodRes)
			})
			.catch(error => {
				const Error = error.message;
				commit('MethodErrorMut', Error)
			});
		},

		MethodByIDAct({commit}, MethodID) {
			axios.get(API_Url + 'docs/method.get?method_link=' + MethodID)
			.then((response) => {
				const MethodRes = response.data.response;
				commit('MethodByIDMut', MethodRes)
			})
			.catch(error => {
				const Error = error.message;
				commit('MethodErrorMut', Error)
			});
		},

		MethodStatusAct({commit}, [MethodID, MethodStatus, AdminId, AdminToken]) {
			let data = {
				'admin_id': AdminId,
				'admin_token': AdminToken,
				'method_id': MethodID,
				'method_status': MethodStatus,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/method.status'
			};
			axios(options)
			.then(commit('MethodSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('MethodErrorMut', Error);
				}
			});
		},

		MethodEditAct({commit}, [MethodID, MethodTitle, MethodLink, MethodDesc, AdminID, AdminToken]) {
			let data = {
				'method_id': MethodID,
				'method_title': MethodTitle,
				'method_link': MethodLink,
				'method_desc': MethodDesc,
				'admin_id': AdminID,
				'admin_token': AdminToken,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/method.edit'
			};
			axios(options)
			.then(commit('MethodSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('MethodErrorMut', Error);
				}
			});
		},

		MethodAddAct({commit}, [MethodTitle, MethodLink, MethodDesc, AdminID, AdminToken]) {
			let data = {
				'method_title': MethodTitle,
				'method_link': MethodLink,
				'method_desc': MethodDesc,
				'admin_id': AdminID,
				'admin_token': AdminToken,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/method.add'
			};
			axios(options)
			.then(commit('MethodSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('MethodErrorMut', Error);
				}
			});
		},
	},
	mutations: {
		AllMethodsMut(state, MethodRes) {
			state.AllMethods = MethodRes;
			state.MethodErrorMut = [];
		},

		MethodByIDMut(state, MethodRes) {
			state.Method = [];
			state.MethodErrorMut = [];
			state.Method = MethodRes;
		},

		MethodErrorMut(state, Error) {
			state.MethodErrorMut = Error;
			state.MethodSuccess = false;
		},

		MethodSuccessMut(state) {
			state.MethodSuccess = true;
			state.MethodErrorMut = [];
		},
	},
	state: {
		MethodError: [],
		AllMethods: {},
		Method: [],
		MethodSuccess: false,
	},
	getters: {
		AllMethodsGet(state) {
			return state.AllMethods;
		},

		MethodByIDGet(state) {
			return state.Method;
		},

		MethodErrorGet(state) {
			return state.MethodError;
		},

		MethodSuccessGet(state) {
			return state.MethodSuccess;
		},
	}
}
